<div class="header">
    <div class="logo">
        <img class="img-fluid" src="assets/imagenes/header.jpg" [routerLink]="['/']">
    </div>
</div>